export default __webpack_public_path__ + "static/howplay-245fe1dcc9105f800b8f833744048091.png";